module.exports = __webpack_public_path__ + "static/media/yeet.f199501e.png";